import appBookings from "../../views/appBookings.html";
import constants from "../../core/constants";
import { getState } from "../../core/utils";

function urlsConfig($stateProvider) {
  "ngInject";

  const base = "bookings";
  const params = [
    "page",
    "sort",
    "limit",
    "user",
    "promotion",
    "status",
    "cash_collection_status",
    "start_date",
    "end_date",
    "date",
    "payment",
    "ride",
    "private_bus_request",
  ];

  $stateProvider.state("bookings", {
    url: getState(base, params),
    parent: "app",
    views: {
      view: {
        template: appBookings,
      },
    },
    reloadOnSearch: false,
    data: { title: "Bookings" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/bookings/bookings.urls.js